import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { UserService } from '../../_service/user/user.service';
import { User } from '../../_model/user/user.model';
import { CookieService } from 'ngx-cookie-service';
import { DnDialogService } from '../../_modules/dn-dialog/dn-dialog.service';
import { ScreenSize, WindowService } from '../../_service/screen-size.service';
import { StorageService } from '../../storageprovider';
import { Unsubscribable } from 'rxjs';

@Component({
  selector: '.user-block',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.scss']
})

export class UserStatusComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    // if(this.unsb!=null)this.unsb();
    this.subscriptions.forEach(p => p.unsubscribe());
  }
  public user;
  public expand = false;
  mouseLeaveDelay = false;
  screenType = ScreenSize;
  screenSize;

  constructor(
    private _userService: UserService,
    private _windowService: WindowService,
  ) {

  }
  private subscriptions: Array<Unsubscribable> = [];

  ngOnInit() {

    // this. unsb = this.store.subscribe(() => this.readState());
    // this.readState();
    this.user = this._userService.user;
    this.subscriptions.push(
      this._userService.userState$.subscribe(user => {
        this.user = user;
        this.readState();
      }

      ),
      this._windowService.size$.subscribe((value: any) => {
        this.screenSize = value;
      }))
    // const token = this._storage.GetSessionData("token");// this._cookieService.get('dn_token');
    // if (token && (!this.user || !this.user.id)) {
    //   this._userService.validateToken(token).subscribe(res => {
    //     if (res) {
    //       this._userService.getAuthorizedUserInfo(this.user).subscribe();
    //     } else {
    //      // this._userService.logout();
    //     }
    //   });
    // }
  }

  readState() {
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = new User(true);
    // Object.assign(this.user, state.currentUser);
    this.expand = false;
  }

  mouseEnter() {
    this.mouseLeaveDelay = false;
    this.expand = true;
  }

  mouseLeave() {
    this.mouseLeaveDelay = true;
    setTimeout(() => {
      if (this.mouseLeaveDelay) {
        this.expand = false;
      }
    }, 300);
  }

  login() {
    this._userService.showLoginDialog(true);
  }

  logout() {
    console.log("isme 2");
    this._userService.logout();
  }

  hideMyCard() {
    this.mouseLeaveDelay = false;
    this.expand = false;
  }
}
